import React from 'react';
import { connect } from 'react-redux';
import { Translate } from 'react-redux-i18n';

const LoginHeader = ({ opico }) => (
  <div className="login-header">
    <div className="brand">
      <span className="logo" />
      <b>{opico && opico.settings.name}</b>
      {' '}
      <Translate value="panel" />
      <small>
        <Translate value="loginText" />
      </small>
    </div>
    <div className="icon">
      <i className="fa fa-lock" />
    </div>
  </div>
);

const mapStateToProps = state => ({
  opico: state,
});

export default connect(mapStateToProps, null)(LoginHeader);
